import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";
import Input from "../../../../../../../components/textbox/Input";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import SelectAutocomplete from "../../../../../../../components/selectAutocomplete/SelectAutocomplete";

class DatiPazienteTubercolosi extends Component {


    state = {
        datiPaziente: {
            nomePaziente: "",
            cognomePaziente: "",
            dataDiNascita: "",
            eta: "",
            sesso: "",
            paeseDiNascita: "",
            dataArrivoInItalia: "",
            professione: "",
            iscritto: "",
            senzaFissaDimora: "",
            viveInCollettivita: "",
            eventualeCollettivita: "",
            regioneDomicilio: "",
            provinciaDomicilio: "",
            comuneDomicilio: "",
            istat: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni,
        province: JSON.parse(sessionStorage.getItem("province")),
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        provincePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice"))
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        let datiPaziente = this.state.datiPaziente

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiPaziente) {
            let datiPazienteProps = this.props.segnalazioneCopia.schedaSpeciale.datiPaziente

            datiPaziente.nomePaziente = datiPazienteProps.nomePaziente ? datiPazienteProps.nomePaziente : this.state.datiPaziente.nomePaziente
            if (datiPazienteProps.regioneDomicilio && datiPazienteProps.regioneDomicilio.length===2){
                datiPazienteProps.regioneDomicilio=datiPazienteProps.regioneDomicilio.concat("0")
            }
            if (this.state.datiPaziente.regioneDomicilio && this.state.datiPaziente.regioneDomicilio.length===2){
                this.state.datiPaziente.regioneDomicilio=this.state.datiPaziente.regioneDomicilio.concat("0")
            }
            datiPaziente.regioneDomicilio = datiPazienteProps.regioneDomicilio ? this.state.regioni[datiPazienteProps.regioneDomicilio] : this.state.datiPaziente.regioneDomicilio
            datiPaziente.provinciaDomicilio = datiPazienteProps.provinciaDomicilio ? this.state.provincePerCodice[datiPazienteProps.provinciaDomicilio] : this.state.datiPaziente.provinciaDomicilio
            datiPaziente.cognomePaziente = datiPazienteProps.cognomePaziente ? datiPazienteProps.cognomePaziente : this.state.datiPaziente.cognomePaziente
            datiPaziente.dataDiNascita = datiPazienteProps.dataDiNascita ? datiPazienteProps.dataDiNascita : this.state.datiPaziente.dataDiNascita
            datiPaziente.eta = datiPazienteProps.eta ? datiPazienteProps.eta : this.state.datiPaziente.eta
            datiPaziente.sesso = datiPazienteProps.sesso ? datiPazienteProps.sesso : this.state.datiPaziente.sesso
            datiPaziente.paeseDiNascita = datiPazienteProps.paeseDiNascita ? this.state.nazioniPerCodice[datiPazienteProps.paeseDiNascita] : this.state.datiPaziente.paeseDiNascita
            datiPaziente.dataArrivoInItalia = datiPazienteProps.dataArrivoInItalia ? datiPazienteProps.dataArrivoInItalia : this.state.datiPaziente.dataArrivoInItalia
            datiPaziente.professione = datiPazienteProps.professione?datiPazienteProps.professione:this.state.datiPaziente.professione
            datiPaziente.iscritto = datiPazienteProps.iscritto ? datiPazienteProps.iscritto : this.state.datiPaziente.iscritto
            datiPaziente.senzaFissaDimora = datiPazienteProps.senzaFissaDimora ? datiPazienteProps.senzaFissaDimora : this.state.datiPaziente.senzaFissaDimora
            datiPaziente.viveInCollettivita = datiPazienteProps.viveInCollettivita ? datiPazienteProps.viveInCollettivita : this.state.datiPaziente.viveInCollettivita
            datiPaziente.eventualeCollettivita = datiPazienteProps.eventualeCollettivita ? datiPazienteProps.eventualeCollettivita : this.state.datiPaziente.eventualeCollettivita
            datiPaziente.comuneDomicilio = datiPazienteProps.comuneDomicilio ? this.state.comuniPerCodice[datiPazienteProps.comuneDomicilio] : this.state.datiPaziente.comuneDomicilio
            datiPaziente.istat = datiPazienteProps.istat ? datiPazienteProps.istat : this.state.datiPaziente.istat

            this.setState({datiPaziente: datiPaziente});
            this.controlloCorrettezza()
            let oggetto = this.createOggettoBE()
            this.props.setDatiPazienteTubercolosi(this.state.datiPaziente, "", oggetto)
        } else if (this.props.datiPaziente) {
            let datiPazienteProps = this.props.datiPaziente
            datiPaziente.nomePaziente = datiPazienteProps.nomePaziente
            datiPaziente.cognomePaziente = datiPazienteProps.cognomePaziente
            datiPaziente.dataDiNascita = datiPazienteProps.dataDiNascita
            datiPaziente.professione = datiPazienteProps.professione
            datiPaziente.paeseDiNascita = datiPazienteProps.comuneNascita ? this.state.comuniPerCodice[datiPazienteProps.comuneNascita]?this.state.comuniPerCodice[datiPazienteProps.comuneNascita]: this.state.nazioniPerCodice[datiPazienteProps.comuneNascita]?this.state.nazioniPerCodice[datiPazienteProps.comuneNascita]:this.state.datiPaziente.paeseDiNascita:""
            datiPaziente.eta = datiPazienteProps.eta
            datiPaziente.sesso = datiPazienteProps.sesso
            datiPaziente.provinciaDomicilio = datiPazienteProps.comuneDomicilio ? datiPazienteProps.comuneDomicilio.codiceProvincia ? this.state.provincePerCodice[datiPazienteProps.comuneDomicilio.codiceProvincia] : "" : ""
            datiPaziente.comuneDomicilio = datiPazienteProps.comuneDomicilio ? datiPazienteProps.comuneDomicilio : ""
            datiPaziente.istat = datiPazienteProps.comuneDomicilio ? datiPazienteProps.comuneDomicilio.codice ? datiPazienteProps.comuneDomicilio.codice : "" : ""
            if (datiPaziente.provinciaDomicilio.codiceRegione && datiPaziente.provinciaDomicilio.codiceRegione.length===2){
                datiPaziente.provinciaDomicilio.codiceRegione=datiPaziente.provinciaDomicilio.codiceRegione.concat("0")
            }
            datiPaziente.regioneDomicilio = datiPaziente.provinciaDomicilio && datiPaziente.provinciaDomicilio.codiceRegione ? this.state.regioni[datiPaziente.provinciaDomicilio.codiceRegione] : ""

            this.setState({datiPaziente: datiPaziente});
            this.controlloCorrettezza()
            let oggetto = this.createOggettoBE()
            this.props.setDatiPazienteTubercolosi(this.state.datiPaziente, "", oggetto)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setDatiPazienteTubercolosi(this.state.datiPaziente, this.validate(), res)
        }

        this.disabledSelectAutocomplete()
    }

    disabledSelectAutocomplete() {
        let condizione = (this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || this.props.segnalazioneDatiSpecificiCopia && (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    validate() {

        if (this.state.datiPaziente.dataDiNascita && Utils.validateDate(this.state.datiPaziente.dataDiNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")) {
            return Utils.validateDate(this.state.datiPaziente.dataDiNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")
        }
        if (this.state.datiPaziente.dataArrivoInItalia && Utils.validateDate(this.state.datiPaziente.dataArrivoInItalia, "Messages.DataArrivoItalia", "Messages.DataArrivoItaliaOdierna")) {
            return Utils.validateDate(this.state.datiPaziente.dataArrivoInItalia, "Messages.DataArrivoItalia", "Messages.DataArrivoItaliaOdierna")
        }

        if ((this.state.datiPaziente && this.state.datiPaziente.paeseDiNascita &&
            (this.state.datiPaziente.paeseDiNascita.codice === "100" || !this.state.datiPaziente.paeseDiNascita.codice) &&
            this.state.datiPaziente.dataArrivoInItalia) || (!this.state.datiPaziente.paeseDiNascita && this.state.datiPaziente.dataArrivoInItalia))
            return "Messages.ERR_01_02_0E_0G"

        return ""

    }


    riceviValore(field, event) {
        let datiPaziente = this.state.datiPaziente
        datiPaziente[field] = event.target.value
        if (datiPaziente.viveInCollettivita !== "1") {
            datiPaziente.eventualeCollettivita = ""
        }
        if (datiPaziente.comuneDomicilio && datiPaziente.comuneDomicilio.codice) {
            datiPaziente.istat = datiPaziente.comuneDomicilio.codice
        } else {
            datiPaziente.istat = ""
        }
        if (!datiPaziente.regioneDomicilio.codice) {
            datiPaziente.provinciaDomicilio = ""
        }
        if (!datiPaziente.provinciaDomicilio.codice) {
            datiPaziente.comuneDomicilio = ""
        }
        this.setState({datiPaziente: datiPaziente})
        this.controlloCorrettezza()
        let oggetto = this.createOggettoBE()
        this.props.setDatiPazienteTubercolosi(this.state.datiPaziente, undefined, oggetto)
    }

    controlloCorrettezza() {
        let datiPaziente = this.state.datiPaziente;
        datiPaziente.corretto = []

        if(!datiPaziente.nomePaziente) datiPaziente.corretto[0] = "Campo \"Nome\" mancante";
        if(!datiPaziente.cognomePaziente) datiPaziente.corretto[1] = "Campo \"Cognome\" mancante";
        if(!datiPaziente.sesso) datiPaziente.corretto[2] = "Campo \"Sesso\" mancante";
        if(!datiPaziente.dataDiNascita || (datiPaziente.dataDiNascita && Utils.isDateInValid(Utils.transformDateForBackend(datiPaziente.dataDiNascita), "-"))) datiPaziente.corretto[3] = "Campo \"Data di nascita\" mancante";
        if(datiPaziente.paeseDiNascita && datiPaziente.paeseDiNascita.codice && datiPaziente.paeseDiNascita.codice !== "100"
            && (Utils.isDateInValid(Utils.transformDateForBackend(datiPaziente.dataArrivoInItalia), "-") || !datiPaziente.dataArrivoInItalia)) datiPaziente.corretto[4] = "Campo \"Se nato all'estero, arrivo in Italia\" mancante";
        if (datiPaziente.viveInCollettivita === "1" && (!datiPaziente.eventualeCollettivita || datiPaziente.eventualeCollettivita === "")) datiPaziente.corretto[5] = "Campo \"collettività\" mancante";
    }

    createOggettoBE() {
        let datiPaziente = JSON.parse(JSON.stringify(this.state.datiPaziente))
        if (datiPaziente.paeseDiNascita && datiPaziente.paeseDiNascita.codice) {
            datiPaziente.paeseDiNascita = datiPaziente.paeseDiNascita.codice
        }
        if (datiPaziente.regioneDomicilio && datiPaziente.regioneDomicilio.codice) {
            datiPaziente.regioneDomicilio = datiPaziente.regioneDomicilio.codice
        }
        if (datiPaziente.provinciaDomicilio && datiPaziente.provinciaDomicilio.codice) {
            datiPaziente.provinciaDomicilio = datiPaziente.provinciaDomicilio.codice
        }
        if (datiPaziente.comuneDomicilio && datiPaziente.comuneDomicilio.codice) {
            datiPaziente.comuneDomicilio = datiPaziente.comuneDomicilio.codice
        }
        let datiPazienteBe = Utils.removeEmptyValueFromObject(datiPaziente)
        return Utils.removeFieldFromObject(datiPazienteBe, "corretto")
    }

    render() {

        const {t} = this.props

        const datiAnagraficiPaziente = (

            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeTubercolosi.DatiAnagraficiPaziente")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello5' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.nome")}
                                    {this.state.datiPaziente.nomePaziente !== "ANONIMO" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}</p>
                                <Input id={"idNomePaziente"}
                                    onChange={this.riceviValore}
                                    field={"nomePaziente"}
                                    value={this.state.datiPaziente.nomePaziente}
                                    placeholder={t("SchedaSpecialeTubercolosi.nome")}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.cognome")}
                                    {this.state.datiPaziente.cognomePaziente !== "ANONIMO" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}</p>
                                <Input id={"idCognomePaziente"}
                                    onChange={this.riceviValore}
                                    field={"cognomePaziente"}
                                    value={this.state.datiPaziente.cognomePaziente}
                                    placeholder={t("SchedaSpecialeTubercolosi.cognome")}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.dataDiNascita")}
                                    <span className={styles.mandatoryColor}>*</span></p>
                                <Calendar
                                    id={"dataDiNascita"} value={this.state.datiPaziente.dataDiNascita}
                                    field={"dataDiNascita"}
                                    newCalendar={true}
                                    onChange={this.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeTubercolosi.dataDiNascita"))}
                                    error={(this.state.datiPaziente.dataDiNascita === "" || this.state.datiPaziente.dataDiNascita == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiPaziente.dataDiNascita), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-1 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.eta")}</p>
                                <Input id={"idEta"}
                                    type={"number"}
                                    min="0"
                                    disabled={true}
                                    onChange={this.riceviValore}
                                    field={"eta"}
                                    value={this.state.datiPaziente.eta}
                                    placeholder={t("SchedaSpecialeTubercolosi.eta")}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                             style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", paddingLeft: "10px"}}>
                                    {t("SchedaSpecialeTubercolosi.sesso")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <div className={"row"}>
                                    <RadioButton id={"sessoM"} name={"sesso"} label={"M"}
                                                 onClick={this.setSesso}
                                                 smallLabel={true} value={"M"}
                                                 checked={this.state.datiPaziente.sesso === "M"}
                                                 newRadio={true}
                                                 onClick={this.riceviValore}
                                    />
                                    <RadioButton id={"sessoF"} name={"sesso"} label={"F"}
                                                 onClick={this.setSesso} smallLabel={true}
                                                 value={"F"}
                                                 checked={this.state.datiPaziente.sesso === "F"}
                                                 newRadio={true}
                                                 onClick={this.riceviValore}>
                                    </RadioButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.paeseDiNascita")}</p>
                                <Autocomplete
                                    id={"paeseDiNascita"}
                                    value={this.state.datiPaziente.paeseDiNascita}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"paeseDiNascita"}
                                    placeholder={t("SchedaSpecialeTubercolosi.paeseDiNascita")}
                                    suggestions={this.state.nazioni}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.dataArrivoInItalia")}
                                    {this.state.datiPaziente.paeseDiNascita && this.state.datiPaziente.paeseDiNascita.codice && this.state.datiPaziente.paeseDiNascita.codice !== "100" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </p>
                                <Calendar
                                    id={"dataArrivoInItalia"} value={this.state.datiPaziente.dataArrivoInItalia}
                                    field={"dataArrivoInItalia"}
                                    newCalendar={true}
                                    onChange={this.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                        t("SchedaSpecialeTubercolosi.dataArrivoInItalia"))}
                                    error={(this.state.datiPaziente.dataArrivoInItalia === "" || this.state.datiPaziente.dataArrivoInItalia == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiPaziente.dataArrivoInItalia), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.professione")}</p>
                            <SelectAutocomplete
                                id={"professione"}
                                disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                onChange={this.riceviValore}
                                newSelect={true}
                                field={"professione"}
                                value={this.state.datiPaziente.professione}
                                functionMap={Utils.mapToArray(OggettiUtili.Professioni).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </SelectAutocomplete>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.IscrittoalSSN")}
                            </p>
                            <div className={"row"}>
                                <RadioButton id={"iscrittoSi"} name={"iscritto"}
                                             label={t("SchedaSpecialeTubercolosi.si")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiPaziente.iscritto === "1"}/>
                                <RadioButton id={"iscrittoNo"} name={"iscritto"}
                                             label={t("SchedaSpecialeTubercolosi.no")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.datiPaziente.iscritto === "2"}>
                                </RadioButton>
                                <RadioButton id={"iscrittoNonNoto"} name={"iscritto"}
                                             label={t("SchedaSpecialeTubercolosi.nonNoto")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"3"}
                                             checked={this.state.datiPaziente.iscritto === "3"}>
                                </RadioButton>
                            </div>
                        </div>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.Senzafissadimora")}
                            </p>
                            <div className={"row"}>
                                <RadioButton id={"senzaFissaDimoraSi"} name={"senzaFissaDimora"}
                                             label={t("SchedaSpecialeTubercolosi.si")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiPaziente.senzaFissaDimora === "1"}/>
                                <RadioButton id={"senzaFissaDimoraNo"} name={"senzaFissaDimora"}
                                             label={t("SchedaSpecialeTubercolosi.no")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.datiPaziente.senzaFissaDimora === "2"}>
                                </RadioButton>
                                <RadioButton id={"senzaFissaDimoraNonNoto"} name={"senzaFissaDimora"}
                                             label={t("SchedaSpecialeTubercolosi.nonNoto")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"3"}
                                             checked={this.state.datiPaziente.senzaFissaDimora === "3"}>
                                </RadioButton>
                            </div>
                        </div>
                        <div className={"col-lg-4"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("SchedaSpecialeTubercolosi.viveInCollettivita")}
                            </p>
                            <div className={"row"}>
                                <RadioButton id={"viveInCollettivitaSi"} name={"viveInCollettivita"}
                                             label={t("SchedaSpecialeTubercolosi.si")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.datiPaziente.viveInCollettivita === "1"}/>
                                <RadioButton id={"viveInCollettivitaNo"} name={"viveInCollettivita"}
                                             label={t("SchedaSpecialeTubercolosi.no")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"2"}
                                             checked={this.state.datiPaziente.viveInCollettivita === "2"}>
                                </RadioButton>
                                <RadioButton id={"viveInCollettivitaNonNoto"} name={"viveInCollettivita"}
                                             label={t("SchedaSpecialeTubercolosi.nonNoto")}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"3"}
                                             checked={this.state.datiPaziente.viveInCollettivita === "3"}>
                                </RadioButton>
                                {this.state.datiPaziente.viveInCollettivita === "1" ?
                                    (<div>
                                        <Input id={"eventualeCollettivita"}
                                               required={this.state.datiPaziente.viveInCollettivita === "1"}
                                               onChange={this.riceviValore}
                                               field={"eventualeCollettivita"}
                                               value={this.state.datiPaziente.eventualeCollettivita}
                                               placeholder={t("SchedaSpecialeTubercolosi.collettivita")}/>
                                    </div>)
                                    : ""
                                }

                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.RegioneDomicilio")}</p>
                                <Autocomplete
                                    id={"idRegioneDomicilio"}
                                    onChange={this.riceviValore}
                                    field={"regioneDomicilio"}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    value={this.state.datiPaziente.regioneDomicilio}
                                    suggestions={this.state.regioni}
                                    placeholder={t("SchedaSpecialeTubercolosi.RegioneDomicilio")}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.provinciaDomicilio")}
                                </p>
                                <Autocomplete id={"idProvinciaDomicilio"}
                                              value={this.state.datiPaziente.provinciaDomicilio}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"provinciaDomicilio"}
                                              placeholder={t("SchedaSpecialeTubercolosi.provinciaDomicilio")}
                                              suggestions={this.state.datiPaziente.regioneDomicilio.codice ?
                                                  Utils.filtroProvinceComuni(this.state.datiPaziente.regioneDomicilio.codice, this.state.province, "codiceRegione") : ""}
                                              disabled={!this.state.datiPaziente.regioneDomicilio.codice}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.comuneDomicilio")}</p>
                                <Autocomplete id={"idComuneDomicilio"}
                                              value={this.state.datiPaziente.comuneDomicilio}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"comuneDomicilio"}
                                              placeholder={t("SchedaSpecialeTubercolosi.comuneDomicilio")}
                                              suggestions={this.state.datiPaziente.provinciaDomicilio.codice ?
                                                  Utils.filtroProvinceComuni(this.state.datiPaziente.provinciaDomicilio.codice, this.state.comuni, "codiceProvincia") : ""}
                                              disabled={!this.state.datiPaziente.provinciaDomicilio.codice}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("SchedaSpecialeTubercolosi.istat")}</p>
                                <Input id={"idIstat"}
                                       onChange={this.riceviValore}
                                       field={"istat"}
                                       value={this.state.datiPaziente.istat}
                                       placeholder={t("SchedaSpecialeTubercolosi.istat")}>
                                </Input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        return (
            <div>
                {datiAnagraficiPaziente}
            </div>
        );
    }

}

export default withTranslation('common')(DatiPazienteTubercolosi)
